<template>
    <base-modal class="intro-advertising-onboarding" :controlled="true" :open="true" :closeable="flow === 'A'" @close="onClose">
        <div class="intro-advertising-onboarding__header">
            <h6 class="text-lg font-bold">Tạo Hình thức Quảng cáo</h6>
        </div>
        <div class="intro-advertising-onboarding__content text-left text-darkblue">
            <div>
                <vue-image class="mb-4" :src="advertisingIntroduceImage" alt="Introduce" width="100%" :ratio="2" />
            </div>

            <p class="text-lg font-normal mb-2">Hình thức quảng cáo là phương thức quảng cáo/quảng bá các chiến dịch đến khách hàng.</p>
            <p class="text-lg font-normal">
                Tạo HTQC sẽ giúp bạn đăng ký chiến dịch mới với các lợi ích hấp dẫn hơn được cập nhật liên tục.
            </p>

            <Button class="mt-4 w-full" @click="start">Bắt đầu ngay!</Button>
        </div>
    </base-modal>
</template>

<script>
import Button from '../../Button/Button.vue';
import BaseModal from '../../Modal/BaseModal.vue';
import VueImage from '../../Image/VueImage.vue';
import userOnboardingService from '../../../core/services/userOnboardingService';
import userAgent from '../../../core/helpers/userAgent';

export default {
    name: 'intro-advertising-onboarding',

    components: {
        Button,
        BaseModal,
        VueImage,
    },

    props: {
        flow: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            advertisingIntroduceImage: require('@assets/images/user-onboarding/htqc-introduce.webp'),
        };
    },

    methods: {
        start() {
            this.$emit('start');
        },

        onClose() {
            window.onbeforeunload = () => {};
            window.onunload = () => {};

            this.$emit('close');
        },
    },

    beforeMount() {
        this.$emit('before');
    },

    mounted() {
        if (userAgent.isEcosystemApple()) {
            window.onbeforeunload = () => {
                return 'Are you sure to quit?';
            };
            
            userOnboardingService.hold({
                step: 0,
                tutorial: 'advertisement',
            });
        } else {
            window.onbeforeunload = () => {
                return 'Are you sure to quit?';
            };

            window.onunload = () => {
                userOnboardingService.hold({
                    step: 0,
                    tutorial: 'advertisement',
                });
            };
        }
    },

    beforeDestroy() {
        window.onbeforeunload = () => {};
        window.onunload = () => {};

        this.$emit('destroyed');
    },
};
</script>

<style lang="scss">
.intro-advertising-onboarding {
    .base-modal__main {
        padding: 0;

        .intro-advertising-onboarding__header {
            padding: 10px 20px 12px;
            background-color: #e9ecef;
        }

        .intro-advertising-onboarding__content {
            padding: 20px;

            img {
                display: block !important;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UserOnboarding/components/IntroAdvertisingOnboarding.vue